import React, { useState, useMemo } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import Bars from './Bars';
import { useAuth } from '../../../utils/Auth';
import { useUserAnalytics } from '../../../utils/customHooks';
import styles from './Analytics.module.css';

export default function Analytics() {

    const { userObj, vcardObj } = useAuth();
    const { account_type, uid } = userObj;
    const { buttons } = vcardObj;
    const analyticsObj = useUserAnalytics(uid);
    const [ showMore, setShowMore ] = useState(false);

    const handleDownloads = useMemo(() => {
        let num = 0;
        if (analyticsObj?.downloads) {
            if (analyticsObj.downloads?.previous) {
                num += analyticsObj.downloads.previous - 1;
            };
            num += Object.keys(analyticsObj.downloads).length;
        };
        return num;
    },[analyticsObj]);
    
    const handleCardViews = useMemo(() => {
        let num = 0;
        if (analyticsObj?.card_views) {
            if (analyticsObj.card_views?.previous) {
                num += analyticsObj.card_views.previous - 1;
            };
            num += Object.keys(analyticsObj.card_views).length;
        };
        return num;
    },[analyticsObj]);

    const handleButtonClicks = useMemo(() => {
        let current = [];
        let past = [];
    
        if (buttons) {
            buttons.forEach((obj, index) => {
                if (analyticsObj?.buttons && analyticsObj?.buttons[obj.added]?.actions) {
                    current.push(
                        <div className={styles.clicksAnalytic} key={obj.data+index} title={`${analyticsObj.buttons[obj.added].data}: ${+Object.keys(analyticsObj.buttons[obj.added].actions).length + (analyticsObj.buttons[obj.added]?.previous ? +analyticsObj.buttons[obj.added]?.previous : 0)}`}>
                            <div className={styles.clicksAnalyticNumber} style={{fontWeight: 'bold'}}>{+Object.keys(analyticsObj.buttons[obj.added].actions).length + (analyticsObj.buttons[obj.added]?.previous ? +analyticsObj.buttons[obj.added]?.previous : 0)}</div>
                            <div className={styles.clicksAnalyticData}>{analyticsObj.buttons[obj.added].data}</div>
                        </div>
                    );
                    
                    delete analyticsObj?.buttons[obj.added]
                } else {
                    current.push(
                        <div className={styles.clicksAnalytic} key={obj.data+index} title={`${obj.data}: ${0}`}>
                            <div className={styles.clicksAnalyticNumber} style={{fontWeight: 'bold'}}>{0}</div>
                            <div className={styles.clicksAnalyticData}>{obj.data}</div> 
                        </div>
                    );
                };
            });
        };
    
        analyticsObj?.buttons && Object.keys(analyticsObj.buttons).forEach((key, index) => {
            let num = 0
            if (analyticsObj?.buttons[key]?.actions) {
                if (analyticsObj.buttons[key]?.previous) {
                    num += analyticsObj.buttons[key].previous;
                };
                num += Object.keys(analyticsObj.buttons[key].actions).length;
            };
            
            past.push(
                <div className={styles.clicksAnalyticPast} key={index} title={`${analyticsObj.buttons[key].data}: ${num}`}>
                    <div className={styles.clicksAnalyticNumberPast} style={{fontWeight: 'bold'}}>{num}</div>
                    <div className={styles.clicksAnalyticDataPast}>{analyticsObj.buttons[key].data}</div>
                </div>
            );
        });
    
        return (
            <>
            <div className={styles.clicksTitle}>
                Current Buttons
                <div className={styles.clicksSubtitle}>Your active button clicks</div>
            </div>
            <div className={styles.clicks}>
                {current}
            </div>
            {past?.length > 0 ? 
                <div className={styles.clicksTitle}>
                    Past Buttons
                    <div className={styles.clicksSubtitle}>Your inactive button clicks</div>
                </div> 
                : <></>}
            <div className={styles.clicks}>
                {past}
            </div>
            </>
        );
    },[buttons, analyticsObj]);

    const handleReturn = () => {
        if(account_type === 'pro') {
            return (
                <div className={styles.more}>
                    <Collapse in={showMore}>
                        <div className={styles.position}>
                            <div className={styles.clicksContainer}>
                                {handleButtonClicks}
                            </div>
                        </div>
                    </Collapse>
                    <div className={styles.btn} onClick={() => setShowMore(!showMore)}>{showMore ? 'Hide' : 'Show More Analytics'}</div>
                </div>
            );
        } else {
            return (
                <div className={styles.more}>
                    <Collapse in={showMore}>
                        <div className={styles.position}>
                            <div className={styles.upgradeContainer}>
                                <div className={styles.upgradeText} >Upgrade to <a href='/upgrade'>Pro</a> for in depth analytics!</div>
                            </div>
                        </div>
                    </Collapse>
                    <div className={styles.btn} onClick={() => setShowMore(!showMore)}>{showMore ? 'Hide' : 'Show More Analytics'}</div>
                </div>
            );
        }
    };


    return (
        <div className={styles.container} >
            <div className={styles.downloads}>
                <div className={styles.word}>Downloads</div>
                <div className={styles.analytic}>{handleDownloads}</div>
                <Bars downloads={analyticsObj.downloads} views={analyticsObj.card_views} />
                <img src='/images/bitsignal-nowords.png' alt='logo' className={styles.logo} />
                <div className={styles.loader}>{analyticsObj?.loading ? <i className='fa-duotone fa-solid fa-spinner fa-spin' /> : null}</div>
            </div>
            <div className={styles.cardViews}>
                <div className={styles.word}>Card Views</div>
                <div className={styles.analytic}>{handleCardViews}</div>
                <Bars downloads={analyticsObj.downloads} views={analyticsObj.card_views} />
                <img src='/images/bitsignal-nowords.png' alt='logo' className={styles.logo} />
                <div className={styles.loader}>{analyticsObj?.loading ? <i className='fa-duotone fa-solid fa-spinner fa-spin' /> : null}</div>
            </div>
            {handleReturn()}
        </div>
    );
};